
<!-- 
  Component qui sert à afficher les dossiers de postits dans le tableau
-->
<template>
  <!-- Container du tableau global -->
  <div
    :id="'folder'+localFolder.id"
    v-if="localFolder && localFolder.sheet_id === currentSheet"
    :style="`
      top: ${localFolder.coord_y}px;
      left: ${localFolder.coord_x}px;
      z-index: ${openSettings ? 100:1};
    `"
    class="folderBody"
    :class="[(hoverWithPost ? 'addPost':'' ),( isOpen ? 'openFolder' : 'collapseFolder'), 'folderBody'+folder.id ]"
    ref="folderBody"
  >

    <!-- @mousedown="(e)=>{startMoving(e);log('mousedown')}" -->
    <div id="header">
      <!-- MENU BUTTONS DOSSIER -->
      <div
        v-if="isOpen && isAutorized && !boardIsClosed"
        class="headerItem"
        id="actionMenu"
      >
        <b-tooltip
          :position="folder.coord_y > 35? 'is-top': 'is-bottom'"
          :label="$t('tooltip.settings')"
        >

          <div
            @click="openingSettings"
            class="menuItem clickable"
            id="settings"
          >
            <i class="fas fa-cog"></i>
          </div>
        </b-tooltip>

        <b-tooltip
          :position="folder.coord_y > 35? 'is-top': 'is-bottom'"
          :label="$t('tooltip.emptyFolder')"
        >

          <div
            @click="deleteFolderAndRestorePosts"
            class="menuItem clickable"
            id="removeFolder"
          ><i class="far fa-object-ungroup"></i></div>
        </b-tooltip>

        <b-tooltip
          :position="folder.coord_y > 35? 'is-top': 'is-bottom'"
          :label="$t('tooltip.deleteFolder')"
        >

          <div
            @click="confirmDelete"
            class="menuItem clickable"
            id="deleteFolder"
          ><i class="fas fa-trash-alt"></i></div>
        </b-tooltip>
      </div>

      <!-- NOM DU DOSSIER-->
      <div
        class="headerItem "
        id="name"
        style="flex: 1 1 auto;"
      >

        <p
          id="nameText"
          :title="this.folder.name"
        >{{this.folder.name}}</p>
      </div>

      <!-- OUVRIR / FERMER UN DOSSIER-->
      <div
        class="headerItem clickable"
        id="toggle"
        style="min-width:35px"
        @click.stop="toggleMenuOpen"
      >
        <i
          v-if="isOpen"
          class="fas fa-compress"
        ></i>
        <i
          v-else
          class="fas fa-expand"
        ></i>
      </div>

    </div>
    <!-- Cors du dossier -->
    <div
      id="postsContainer"
      v-if="this.localFolder "
      :class="{'addPost': hoverWithPost}"
    >
      <div
        id="gridLayoutContaine"
        v-if="this.localFolder.posts.length > 0 && layout.length > 0"
      >

        <!-- Affichage en mode "dossier ouvert" -->
        <GridLayout
          :class="{'addPost': hoverWithPost}"
          ref="gridLayout"
          v-show="isOpen"
          :layout.sync="layout"
          :col-num="widthPost"
          :row-height="44"
          :is-resizable="false"
          @layout-updated="layoutUpdatedEvent"
        >
          <GridItem
            :class="{'addPost': hoverWithPost}"
            ref="gridItems"
            class=""
            :style="`z-index: ${layout.length - key};`"
            v-for="(item,key) in layout"
            :x="item.x"
            :y="item.y"
            :w="item.w"
            :h="item.h"
            :i="item.i"
            :key="'gridItem'+key"
          >
            <svg
              :id="'draggablePost'+item.postID"
              :class="'draggablePost'+folder.id"
              :width="svgWidth(item)"
              :height="svgHeight(item) "
            >

              <post
                :class="{'addPost': hoverWithPost}"
                ref="post"
                v-if="getPost(item.postID) !== undefined"
                :post="getPost(item.postID)"
              />
            </svg>
          </GridItem>
        </GridLayout>

        <!-- Affichage en mode "dossier fermé" -->
        <div
          v-show="!isOpen"
          id="dotContainer"
        >
          <div
            :class="{'addPost': hoverWithPost}"
            class="dot"
            v-for="(post, key) in sortedPosts"
            :key="'dot'+key"
            :style="`background-color:${post.couleur}`"
          ></div>
        </div>
      </div>
      <!-- Affichage en mode "dossier vide" -->
      <div
        id="emptyBody"
        v-else
      >
      </div>
    </div>

  </div>
</template>
<script>
import EditFolderPopup from './modal/EditFolderPopup'
import post from '../post/post'
import { createNamespacedHelpers } from 'vuex'
import {
  GridLayout,
  GridItem
} from 'vue-grid-layout'
import debounce from 'lodash.debounce'
import interact from 'interactjs'
const { mapState } = createNamespacedHelpers('board')

export default {
  name: 'folder',
  components: {
    post,
    GridLayout,
    GridItem,
    EditFolderPopup
  },
  data () {
    return {
      openSettings: false, // bool, ouvre la modale des params
      newName: this.folder.name, // variable tampon pour le changement de nom
      nameEditing: false, // bool, active le changement de nom
      widthPost: 2, // nombre de colonne de postits, non implémenté pour le moment
      layout: [], // disposition des posts dans la grille du dossier, voir https://www.npmjs.com/package/vue-grid-layout/v/2.3.8 pour la doc
      isOpen: false, // si le dossier est grand ou petit
      localFolder: this.folder, // object local du dossier
      isMoving: false, // bool, vrai si l'user déplace ce dossier
      offsetX: 0, // chiffre représentant la distance en X entre le click de l'utilisateur et le bord du dossier, utilisé pour le déplacement
      offsetY: 0, // chiffre représentant la distance en Y entre le click de l'utilisateur et le bord du dossier, utilisé pour le déplacement
      debounced: debounce((e) => { this.stopMoving(e) }, 500), // Fonction servant au déplacement sur mobile. Active la fonction stopMoving si debounced n'est plus appelé pendant 500ms
      lockDebouncing: debounce((e) => { this.move(e) }, 500, { 'leading': true }),
      boardRef: null,
      lastKnownScrollPosition: { x: 0, y: 0 },
      ticking: false,
      layoutCopy: [],
      editingPostitNb: NaN,
      bodyStyle: ''
    }
  },

  watch: {
    folder: {
      handler (value) {
        this.localFolder = value
        this.oldName = this.localFolder.name
        if (this.localFolder && this.localFolder.posts.length > 0) {
          // console.log('UPDATE LAYOUT')
          this.layout = this.calculateLayout(true)
          setTimeout(() => {
            this.layout = this.calculateLayout(true)
          }, 100)
          if (this.$refs.gridLayout) {
            this.$refs.gridLayout.placeholder.w = 0 // hides the placeholder if it didn't automatically
          }
        }
      },
      deep: true
    }
  },
  props: {
    folder: Object
  },
  computed: {
    hoverWithPost () { // should detect if a post is currently moving
      if (this.$parent.$refs && this.$parent.$refs.post) {
        let postMoving = this.$parent.$refs.post.filter(post => post.moving === true)
        return postMoving.length === 1
      } else {
        return false
      }
    },
    isAutorized () { // checks if the user is authorized to do the action
      if (this.current.mode === 'libre') {
        return true
      } else {
        return this.$route.params.url_moderateur
      }
    },
    boundingRect () { // Doit renvoyer les coordonnées du folderBody
      let rect = this.getBoundingClientRect(this.$refs.folderBody)
      let updaters = this.isMoving
      return rect
    },
    sortedLayout () {
      let layout = [...this.layout]
      if (layout.length > 0) {
        layout = layout.sort((a, b) => {
          if (a.x === b.x) {
            return a.y - b.y
          } else {
            return a.x - b.x
          }
        })
      }

      return layout
    },
    sortedPosts () {
      let posts = this.folderedPosts
      posts = posts.sort((a, b) => {
        return a.zindex - b.zindex
      })
      return posts
    },

    gridItems () {
      if (this.isOpen) {
        return this.$refs.gridItems
      } else {
        return false
      }
    },

    folderedPosts () {
      let posts = this.localFolder.posts
      if (this.localFolder.posts.length > 0) {
        posts.forEach(post => {
          post.coord_x = 0
          post.coord_y = 0
        })
      }
      return posts
    },
    ...mapState({
      currentSheet: 'currentSheet',
      current: 'current',
      menu: 'menu',
      postlist: 'currentBoardPost',
      linking: 'linking',
      boardIsClosed: "boardIsClosed"
    })
  },
  mounted () {

    document.querySelector('#boardMeeting').addEventListener('scroll', (e) => { // Fonction qui permet de se déplacer 
      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          this.followScroll(document.querySelector('#boardMeeting').scrollTop, document.querySelector('#boardMeeting').scrollLeft)
          this.ticking = false
        })

        this.ticking = true
      }
    })

    let myDraggable = document.querySelector('.folderBody' + this.folder.id)
    this.boardRef = document.querySelector('#svgBoard')
    this.initInteract(myDraggable)

    this.initPostDragging()
    // this.$refs.post = this.$parent.$refs.post
    this.layout = this.calculateLayout() // calcule le layout de base
    // setTimeout(() => {
    // }, 500)
  },
  updated () {
    if (this.$refs['post']) {
      this.$refs['post'].forEach(post => {
        post.wrapTextRect()
      })
    }
  },
  methods: {

    layoutUpdatedEvent (newLayout) {
      this.layoutCopy = newLayout
      newLayout.forEach(item => {
        if (item.y < 0) { item.y = 0 }
      })
    },
    followScroll (y, x) {
      if (this.isMoving) {
        this.folder.coord_y += y - this.lastKnownScrollPosition.y
        this.folder.coord_x += x - this.lastKnownScrollPosition.x
      }
      this.lastKnownScrollPosition.y = y
      this.lastKnownScrollPosition.x = x
    },
    toggleMenuOpen () {
      this.isOpen = !this.isOpen
      setTimeout(() => {
        this.layout = this.calculateLayout(true)
      }, 100)
    },
    initPostDragging () {
      interact('.draggablePost' + this.folder.id).draggable({
        onmove: (e) => { },
        onend: this.gridItemMove
      })
    },
    // https://interactjs.io/docs/
    initInteract (selector) {
      interact.dynamicDrop(true)
      interact(selector).draggable({
        // enable inertial throwing
        inertia: false,
        ignoreFrom: '#postsContainer',
        // keep the element within the area of it's parent
        modifiers: [
          interact.modifiers.restrictRect({
            restriction: '#mySpan',
            endOnly: true
          })
        ],
        restrictRect: {
          restriction: '#mySpan',
          endOnly: true
        },
        // enable autoScroll
        // autoScroll: true,
        autoScroll: {
          container: document.querySelector('#boardMeeting'),
          margin: 50,
          distance: 5,
          interval: 10,
          speed: 500
        },

        // call this function on every dragmove event
        onmove: this.move,
        // call this function on every dragend event
        onend: this.stopMoving
      }).dropzone({
        ondrop: (event) => {
          let postId = event.relatedTarget.id
          let folderId = event.target.id

          this.checkAddPostit(postId)
        }
      })
    },
    svgWidth (item) {
      let width = 250
      let post = this.$refs.post ? this.$refs.post.filter(post => post.id === item.postID)[0] : undefined
      if (post) {
        width = post.isMenuOpen ? 450 : width
      }
      return width
    },
    svgHeight (item) {
      let height = (44 * item.h)
      let post = this.$refs.post ? this.$refs.post.filter(post => post.id === item.postID)[0] : undefined
      if (post) {
        height = post.$el.getBBox().height
      }
      return height
    },
    confirmDelete () { // popup de confirmation, appelée quand l'user click sur tout supprimer
      this.$buefy.dialog.confirm({
        title: this.$i18n.t('dialog.deleteFolder'),
        message: this.$i18n.t('dialog.deleteFolderAllPosts'),
        confirmText: this.$i18n.t('dialog.confirm'),
        cancelText: this.$i18n.t('dialog.cancel'),
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.deleteFolderAndPosts()
      })
    },
    openingSettings () { // ouvre la modale des params, appelée quand m'user click sur l'engrenage
      this.$parent.$parent.editingFolder = this.localFolder
      this.$parent.$parent.editFolderActive = true
    },
    async deleteFolderAndRestorePosts () { // extrait les post du dossier, puis supprime le dossier
      let posts = this.localFolder.posts // on récup les posts à extraire
      let responses = []
      let data = []
      posts.forEach((post, key) => {
        post.folder_id = null // on leur enleve l'id du folder
        post.coord_x = this.localFolder.coord_x // on les met sur le meme X que le dossier
        post.coord_y = (this.localFolder.coord_y + (key * 100) % 2160) // on les met sur le meme Y que le dossier au début, puis on descend de 80px à chaque post. Si on dépasse 2160 px, retour au début
        post.board_id = this.current.id
        post.id = post.id

        data.push(post) // save all modifications
      })

      fetch(`${process.env.URL_SSO_API}brainstorming/public/board/${this.current.id}/post`, { // on envoie tous les posts d'un coup vers postController::updateMultiple
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'urlparticipant': this.current.url_participant
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: JSON.stringify(data)
      }).then(res => { // Une fois que les posts ont été retirer, on supprime le dossier
        this.localFolder.posts = []
        let url = `${process.env.URL_SSO_API}brainstorming/public/board/${this.current.id}/folder/${this.localFolder.id}`
        fetch(url, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'urlparticipant': this.current.url_participant
          },
          body: JSON.stringify(this.localFolder)
        })
      })
    },
    deleteFolderAndPosts () { // similaire à deleteFolderAndRestorePosts juste au dessus
      let posts = this.localFolder.posts
      let responses = []
      let data = []
      posts.forEach((post, key) => {
        post.folder_id = null
        post.etat = 'poubelle' // on place les posts dans la poubelle au lieu de les replacé sur le board
        post.x = this.localFolder.coord_x // mais on change quand même leurs coordonnées au cas où l'user les restore
        post.y = (this.localFolder.coord_y + (key * 80) % 2160)
        post.board_id = this.current.id
        post.id = post.id

        data.push(post) // save all modifications
      })

      fetch(`${process.env.URL_SSO_API}brainstorming/public/board/${this.current.id}/post`, { // sends them
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'urlparticipant': this.current.url_participant
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: JSON.stringify(data)
      }).then(res => {
        this.localFolder.posts = []
        let url = `${process.env.URL_SSO_API}brainstorming/public/board/${this.current.id}/folder/${this.localFolder.id}`
        fetch(url, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'urlparticipant': this.current.url_participant
          },
          body: JSON.stringify(this.localFolder)
        })
      })
    },
    updateFolder () { // Fonction qui met à jour le dossier en BDD et envoie une MàJ en temps réel aux autres clients
      let url = `${process.env.URL_SSO_API}brainstorming/public/board/${this.current.id}/folder/${this.folder.id}`
      let data = JSON.parse(JSON.stringify(this.folder))
      fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'urlparticipant': this.current.url_participant
        },
        body: JSON.stringify(data)
      }
      )
    },
    checkAddPostit (postId) { // fonction srevant à rajouter un post au dossier
      if (this.$parent.$refs && this.$parent.$refs.post) {
        // this.$parent.$refs.post.forEach(postRef => { // on regarde tous les composants posts extistants
        let postRef = this.$parent.$refs.post.find(localPostRef => 'postitnumber' + localPostRef.id === postId)
        let post = this.postlist.find(postInList => 'postitnumber' + postInList.id === postId)// on prends l'objet post en utilisant l'id du component vue
        if (postRef && post) {
          post.folder_id = this.localFolder.id // on l'ajoute au dossier
          post.zindex = this.localFolder.posts.length + 1 // on le met à la fin du dossier
          postRef.folder_id = this.localFolder.id // on déplace aussi le component
          postRef.zindex = this.localFolder.posts.length + 1 // on syncronise l'index
          this.localFolder.posts.push(post) // on le pousse dans la liste des posts du dossier

          this.$store.dispatch('board/updatePostData', { // on envoie les modifs en BDD
            board: this.$store.state.board.current,
            post: postRef
          })
        }
      }
    },
    getBoundingClientRect (element) { // fonction outil, renvoie un vrai object au lieu du nodeList renvoyé par la fonction de base
      const { top, right, bottom, left, width, height, x, y } = element.getBoundingClientRect()
      return { top, right, bottom, left, width, height, x, y }
    },
    log (e, ...args) { // fonction outil, permet d'utiliser un console. log dans la partie html d'un composant vue
      console.log(e, ...args)
    },
    gridItemMove (e) { // fonction qui permet de sortir un post du dossier
      let rectPost = this.getBoundingClientRect(e.target) // on prends les coordonées du post
      let rectFolder = this.getBoundingClientRect(e.target.parentElement.parentElement.parentElement.parentElement.parentElement) // on prends les coordonées du dossier
      // console.log(rectFolder)
      // console.log('post left : ', rectPost.left, 'folder left : ', rectFolder.left)
      // console.log('post top : ', rectPost.top, 'folder top : ', rectFolder.top)
      // console.log('post  right : ', rectPost.right, 'folder  right : ', rectFolder.right)
      // console.log('post bottom : ', rectPost.bottom, 'folder bottom : ', rectFolder.bottom)
      // console.log('post width : ', rectPost.width, 'folder width : ', rectFolder.width)
      // console.log('post height : ', rectPost.height, 'folder height : ', rectFolder.height)

      if ( // check si le post est dans le dossier
        (rectPost.right >= rectFolder.left && // check si le coté droit du post est plus grand que le coté gauche du dossier
          rectPost.left <= rectFolder.right) && // check si le coté gauche du post est plus petit que le coté droit du dossier
        (rectPost.bottom >= rectFolder.top && // check si le coté bas du post est plus grand que le coté haut du dossier
          rectPost.top <= rectFolder.bottom) // check si le coté haut du post est plus petit que le coté bas du dossier
      ) {
        // console.log('post was dropped INSIDE the folder')
      } else if (this.isAutorized && !this.boardIsClosed) {
        let postId = parseInt(e.target.id.replace(/^\D+/g, ''))
        // console.log('post was dropped OUTSIDE the folder')
        // try {
        this.removePost(postId, e.clientX - document.querySelector('#svgBoard').getBoundingClientRect().x, e.clientY - document.querySelector('#svgBoard').getBoundingClientRect().y)
        // } catch (error) {
        //   console.log(error)
        //   this.$buefy.toast.open({
        //     type: 'is-danger',
        //     message: error
        //   })
        // }
      }
    },
    removePost (id, x, y, zindex = 1) { // fonction sortant un post du dossier
      // try {
      // this.$refs.post.forEach(postRef => { // on parcourt les compents vue des posts
      //   if (postRef.id === id) { // on trouve celui qui correspond à l'id donné
      let post = this.postlist.find(postInList => postInList.id === id) // on trouve l'object correspondant
      // console.log(post)
      // on update tout ce qu'il faut

      post.folder_id = null
      post.zindex = zindex
      post.coord_x = x
      post.coord_y = y
      post.x = x
      post.y = y
      post.clientX = x
      post.clientY = y
      post.moving = false

      this.$store.dispatch('board/updatePostData', {// on envoie les modifs en BDD
        board: this.$store.state.board.current,
        post: post
      }).then(
        () => {
          this.folder.posts.splice(this.folder.posts.findIndex(postToSplice => postToSplice.id === id), 1)

          this.updateFolder()
        }
      )
      // on coupe la liste des posts du dossier à l'index du post
      this.layout.splice(this.layout.findIndex(item => item.postID === id), 1) // on coupe la liste des posts du dossier à l'index du post
      //   }
      // })
      // } catch (error) {
      //   console.log(error)
      //   this.$buefy.toast.open({
      //     type: 'is-danger',
      //     message: error
      //   })
      // }
    },
    move (e) { // fonction du déplacement du dossier, appelée à chaque fois qu'on survole le board avec la souris, ou qu'on traine le doigt sur écran tactile
      if ((this.$route.name === 'animer' || this.current.mode === 'libre') && !this.boardIsClosed) {
        this.isMoving = true
        this.localFolder.coord_x = this.localFolder.coord_x + e.dx
        this.localFolder.coord_y = this.localFolder.coord_y + e.dy

        this.closePostsEditingMenu()
      }
    },
    stopMoving (e) { // fonction appelée a la fin du déplacement du dossier
      this.isMoving = false
      this.updateFolder()
    },
    getPost (id) { // fonction outil pour récup un post en fonction de son id
      let post = this.folderedPosts.find(folderedPost => {
        return folderedPost.id === id
      })
      return post
    },
    calculateLayout (changeHeightOnly = false) { // fonction qui renvoie le layout nécessaire à la grille du plugin
      let tempLayout = []
      let posts = [...this.localFolder.posts] // on prends chaque posts du dossier
      posts.forEach((post, index) => { // on les parcourt
        let layoutItem = this.layoutCopy.find(item => { return item.postID === post.id })
        let x = 0
        let y = 0
        if (layoutItem === undefined) {
          x = index % 2 // la pos X est égale au reste de la division entière de l'index du post. e.g. si index = 3 => 3 % 2 = 1. si index = 4 => 4 % 2 = 0
          y = Math.floor(index / 2) // la pos Y est égale à l'entier de l'index du post diviser par 2. e.g. si index = 5 => Math.floor(5/2) = 2
        } else {
          //   let item = this.layout.find(item => { return item.postID === post.id })
          x = layoutItem.x
          y = layoutItem.y
        }

        let height = Math.ceil(post.contenu.length / 130) + 1

        let postRef = this.$refs.post ? this.$refs.post.filter(item => item.id === post.id)[0] : undefined
        if (postRef) {
          height = postRef.$el.getBBox().height / 46
        }
        tempLayout.push({ 'x': x, 'y': y > 0 ? y : 0, 'w': 1, 'h': height, 'i': post.id, 'postID': post.id }) // on sauvegarde toutes les coordonnées dans le tableau temp
      })
      return tempLayout // on renvoie le tout
    },
    closePostsEditingMenu () {
      if (this.$refs && this.$refs.post) {
        this.$refs.post.forEach(post => {
          post.isMenuOpen = false
        })
      }
    }
  }
}
</script>

<style scoped>
.show {
  border: 1px solid green;
}
.addPost {
  cursor: url("/static/back-arrow.png"), auto;
}
#header {
  background-color: #424a60;
  color: #e6ecf0;
  display: flex;
  flex-flow: row nowrap;
  border-radius: 5px 5px 0px 0px;
  cursor: grab;
}

.openFolder {
  width: 540px;
}
.collapseFolder {
  width: 150px;
}

#toggle {
}
.nameInput > .icon > i {
  pointer-events: auto !important;
}
#name {
  height: 25px;
}
#name > * {
  height: 25px;
}
#name > * > * {
  height: 25px !important;
}

#actionMenu {
  min-width: max-content;
  display: flex;
  flex-flow: row nowrap;
}

.menuItem {
  margin-left: 5px;
  margin-right: 5px;
}
#changeSheet img {
  margin-top: 3px;
  margin-bottom: -3px;
}
.headerItem {
  margin: 3px 0;
}
.clickable {
  cursor: pointer;
}
#name {
  margin: 3px auto;
  margin-right: 30px;
  max-width: 100%;
}
#nameInput {
  max-width: 100%;
}
#nameText {
  user-select: none;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.folderBody {
  /* box-shadow: 0px 0px 5px black; */
  z-index: 1;
  touch-action: none;
  position: absolute;
  border-radius: 5px;
  background-color: #d2cdcd;
}

#dotContainer {
  display: flex;
  flex-flow: row wrap;
  padding: 5px;
}
.dot {
  margin: 5px;
  width: 25px;
  height: 25px;
  border-radius: 50%;
}

#emptyBody {
  height: 25px;
}

/* @supports (backdrop-filter: blur(2px)) {
  .folderBody {
    box-shadow: 0px 0px 5px black;
    z-index: 1;
    touch-action: none;
    position: absolute;
    border-radius: 5px;
    background-color: #d2cdcd33;
    backdrop-filter: blur(2px);
  }
} */
</style>



// WEBPACK FOOTER //
// src/components/board/Folders.vue